import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const loansData: NavItem[] = [
  {
    label: 'About',
    to: '/pages/loans/about'
  },
  {
    label: 'Documentation',
    to: '/pages/loans/documentation'
  },
  {
    label: 'Terms',
    to: '/pages/loans/terms'
  },
  {
    label: 'Process',
    to: '/pages/loans/process'
  },
  {
    label: 'Stats',
    to: '/pages/loans/stats'
  }
];
